/// <amd-dependency path='VSS/LoaderPlugins/Css!TestManagement' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import { TestHubView } from "TestManagement/Scripts/TFS.TestManagement.TestLiteView";

export interface IChartsProps {
    suite: any;
    plan: any;
    tfsContext: any;
}

// This is a proxy component to load the charts tab in test hub refresh using LegacyComponent
class ChartsProxy extends React.Component<IChartsProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        let chartsView: TestHubView = new TestHubView();
        if (chartsView) {
            chartsView._initializeAndShowTestChartsForTestHubRefresh(this.props.suite, this.props.plan, this.props.tfsContext);
        }
    }
}

registerLWPComponent("charts-proxy", ChartsProxy);
